import script from "./ReceiptPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptPrint.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptPrint.vue?vue&type=style&index=0&id=33186dae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33186dae"]])

export default __exports__